var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',_vm._g(_vm._b({},'Button',_vm.$attrs,false),_vm.$listeners),[(_vm.icone)?_c('v-icon',{attrs:{"left":""}},[_vm._v(" "+_vm._s(_vm.icone)+" ")]):_vm._e(),_vm._t("img"),_vm._v(" "+_vm._s(_vm.texto)+" ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }